
import {Vue, Component, Prop } from 'vue-property-decorator';
import VGenericTable from "@/components/bootstrap/vGenericTable.vue";
import {mapState} from "vuex";
import {LocalizationState} from "@/store/modules/LocalizationModule";
import {AminoAcidScoreDto} from "@/models/Recipes/AminoAcidScoreDto";
import RecipesRepository from "@/utils/API/RecipesRepository";
import VPreLoader from "@/components/vPreLoader.vue";

import { round } from "@/utils/Helpers";

@Component({
  components: {VPreLoader, VGenericTable },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule
    }),
  },
  methods: {
    round
  }
})
export default class vAminoAcidScoreReport extends Vue {
  @Prop() recipeId!: number;
  localizationState: LocalizationState;

  isLoading: boolean = false;
  reportData: AminoAcidScoreDto;

  getAminoAcidScoreReport() {
    this.isLoading = true;
    RecipesRepository.getAminoAcidScore(this.recipeId)
      .then((response) => {
        this.isLoading = false;
        this.reportData = response.data.result;
      })
      .catch((reason) => { console.error(reason); });
  }

  get translations() {
    return this.localizationState.translations;
  }

  created() {
    this.getAminoAcidScoreReport();
  }
}
